import React, { useState, useEffect, useRef, useContext } from 'react';
import { ButtonC } from 'Common/Buttons';
import Axios from 'functions/Axios';
import {
  Addfolder,
  GET_ASSET_TYPE_FILTER_DATA,
  GET_FOLDER_COLORS,
  GET_INSIDE_FOLDER_DATA,
  ListofAllAssetsURL,
  UPLOAD_FILE_DATA,
  UploadAssetsURL,
  folderdata,
  getSingleFolder,
} from '../DAM_API/urls';
import { Assitdata } from './assitdata';
import Uploadfile from '../Uploadfile';
import moment from 'moment';
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import close from '../../../assets/V2-images/close.svg';
import SpinnerLoader from './../../SpinnerLoader';
import { useLocation } from 'react-router-dom';
import { Viewbuttonfolderv2 } from 'Common/Viewbuttonfolder/index-v2';
import FolderData from '../Folders';
import { toast } from 'react-toastify';
import { SVG } from 'Common/commonsvg';
import { GridFolderData } from '../Folders/gridfolder';
import InputC from 'Common/Inputs/index.tsx';
import { DAM_SVG } from '../DamAssets';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  setInsideFolderData,
  SetSelctedFoldersData,
  SelectedAssetData,
  setInnerFolderDetails,
} from 'actions/damActions';
import Nodatacomponent from 'components/Nodatacomponent';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import SelectionActions from '../Components/Featured/selectionActions';
import { useDropzone } from 'react-dropzone';
import DropZone from 'Common/Dropzone';
import CommonTableDrived from '../Components/Featured/CommonTableDrived';
import CommonTable from '../Components/Featured/CommonTable';
import { useContainerRef } from 'context/ContainerRefContext';

export const uploadFiless = async (acceptedFiles, folderId) => {
  try {
    let data = new FormData();
    if (acceptedFiles?.length > 2000) {
      toast.info('You cannot upload a folder which has more than 2000 files at a time.');
      return;
    }
    acceptedFiles.forEach((f) => {
      data.append('files', f);
      data.append('isVideo', f.type.includes('video'));
      data.append('isStreamable', f.type.includes('video'));

      if (f.path?.includes('/')) {
        const cleanPath = f.path.replace(/^(\.\/|\/)/, '');
        if (cleanPath.includes('/')) {
          data.append('relativePaths', cleanPath);
        }
      } else {
        data.append('relativePaths', '');
      }
    });
    data.append('folderId', folderId ?? null);
    const res = await Axios.post(UploadAssetsURL, data);
  } catch (err) {
    console.error(err);
  }
};

const AssetsData = () => {
  const { containerRef: listInnerRef, setScrollHandler } = useContainerRef();
  const [assets, setAssets] = useState({ files: [] });
  const [selectedFormats, setSelectedFormats] = useState([]);
  const [selectorientation, setselectorientation] = useState([]);
  const [selectassettype, setselectassettype] = useState([]);
  const [filterAssetType, setfilterAssetType] = useState();
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFace, setSelectedFace] = useState();
  const [createdon, setcreatedon] = useState([]);
  const [selectdate, setselectdate] = useState('');
  const [selecttDateValidator, setSelectDateValidator] = useState({});
  const [uploadedData, setUploadedData] = useState([]);
  const [assetTags, setAssetsTags] = useState();
  const [tagValue, setTagValue] = useState([]);
  const [modal, setModal] = useState(false);
  const [showupload, setshowupload] = useState(false);
  const [loadedData, setLoaded] = useState(0);
  const [totalData, setTotal] = useState(0);
  const [disableDropBox, setDisableDropBox] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [files, setFiles] = useState([]);
  const [previewFlag, setPreviewFlag] = useState(false);
  const [folderId, setFolderId] = useState(null);
  const [isCollectionAdded, setIsCollectionAdded] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isfirstLoad, setIsFirstLoad] = useState(true);
  const location = useLocation();
  const state = location.state;
  const collectionID = state ? state.collectionID : null;
  const collection_name = state ? state.collection_name : null;
  const [Designationdata, setDesignationdata] = useState(null);
  const [iscustomValue, setIsCustomValue] = useState(false);
  const [searchExtesionValue, setSearchExtensionValue] = useState('');
  const [isExtension, setIsExtension] = useState(false);
  const [filtereddata, setfiltereddata] = useState([]);
  const [datafilter, setdatafilter] = useState([]);
  const [folderselect, setfolderselect] = useState([]);
  const [subfolder, setsubfolder] = useState([]);
  const [addcollection, setaddcollection] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [activeId, setActiveId] = useState();
  const [openFolderModal, setOpenFolderModal] = useState(false);
  const { isInsideFolder, insideFolderId, selectedAssets, selectedFolders } = useSelector(
    (state) => state.dam,
  );
  const [visualImageData, setVisualImageData] = useState();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [currentModalFolderName, setCurrentModalFolderName] = useState('');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [openFolderSection, setOpenFolderSection] = useState(false);
  const [assetToken, setAssetToken] = useState('123');
  const [openAdditionDialog, setOpenAdditionDialog] = useState(false);
  // const listInnerRef = useRef();
  const [metaData, setMetaData] = useState({
    currentPage: 1,
    isScrolling: false,
    external: 'la la la ',
  });
  const [statsChecker, setStatsChecker] = useState(false);
  const [isAvailableData, setisAvailableData] = useState(true);
  const [allFoldersData, setAllFoldersData] = useState([]);
  const [imageSearchModal, setImageSearchModal] = useState(false);
  const [imageSearchLoading, setImageSearchLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    JSON.parse(localStorage.getItem('viewMode'))?.id
      ? JSON.parse(localStorage.getItem('viewMode'))
      : { id: 1 },
  );
  const [visualSearchModal, setVisualSearchModal] = useState({
    open: false,
    result: '',
    data: '',
  });
  const [loadingValue, setLoadingValue] = useState(false);
  const wrapperRef = useRef(null);
  const box1Ref = useRef(null);
  const box2Ref = useRef(null);
  const box3Ref = useRef(null);
  const datashow = async (IsErase = false) => {
    if (!isAvailableData) {
      return;
    }
    setIsLoading(true);

    const { isCustom, ...filteredSelectDate } = selectdate || {};
    let result = {};

    const infoList = selectassettype.filter((item) => typeof item === 'object' && item.extensions);
    const extList = selectassettype.filter((item) => typeof item === 'string');
    infoList.forEach((info) => {
      result[`"${info.type}"`] = [];
    });

    extList.forEach((ext) => {
      infoList.forEach((info) => {
        if (info.extensions.includes(ext)) {
          result[`"${info.type}"`].push(ext);
        }
      });
    });

    try {
      const data = await Axios.post(`${ListofAllAssetsURL}`, {
        pageNo: metaData?.currentPage - 1,
        rowSize: 30,
        folderIds: folderselect,
        orientations: selectorientation,
        dominantColor: selectedColor,
        filterTypeExtension: result,
        personCount: selectedFace,
        uploadedBy: uploadedData?.includes('By me')
          ? true
          : uploadedData?.includes('By Others')
            ? false
            : '',
        ...(selectdate?.isCustom ? { ...filteredSelectDate } : { startDate: `${selectdate}` }),
        tagList: tagValue,
        searchKeyword: isExtension ? searchExtesionValue : search,
      });

      setAssetToken(data?.data?.assetToken);

      setisAvailableData(metaData?.currentPage * 30 < data?.data?.metadata?.totalAmountOfElements);
      if (data?.data?.data?.files?.length > 0) {
        const _updated_data1 = metaData?.isScrolling
          ? [...assets.files, ...data.data.data.files]
          : [...data.data.data.files];
        setAssets({
          files: _updated_data1?.map((item) => ({
            ...item,
            damFileId: item?.assetId,
          })),
        });

        const _updated_data2 = metaData?.isScrolling
          ? [
            ...selectedAssets?.map((item) => ({
              ...item,
              isSelected: item?.isSelected ?? false,
            })),
            ...data.data.data.files,
          ]
          : [...data.data.data.files];

        dispatch(
          SelectedAssetData(
            _updated_data2?.map((item) => ({
              ...item,
              damFileId: item?.assetId,
            })),
          ),
        );

        setStatsChecker(true);
      } else {
        setAssets({
          files: [],
        });
      }

      // setMetaData((prev) => ({
      //   ...prev,
      //   isScrolling: false,
      // }));

      setdatafilter(data, data.data);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching assets:', error);
    }
  };

  const getAllSearchData = async (value) => {
    const noFilters =
      !search &&
      selectorientation?.length === 0 &&
      selectedColor?.length === 0 &&
      folderselect?.length === 0 &&
      !selectedFace &&
      (!uploadedData || uploadedData.length === 0) &&
      (!selectdate ||
        (typeof selectdate === 'object'
          ? Object.keys(selectdate).length === 0
          : String(selectdate).trim().length === 0)) &&
      (!tagValue || tagValue.length === 0) &&
      (!selectassettype || selectassettype.length === 0) &&
      searchExtesionValue?.length === 0;

    if (noFilters && selectdate !== 0) {
      getAllFolders();
      datashow();
      return;
    }

    !insideFolderId && setIsLoading(true);

    if (search && search?.length > 0 && search?.length < 3) {
      setIsLoading(false);
      return;
    }
    try {
      const { isCustom, ...filteredSelectDate } = selectdate || {};
      let resulta = {};

      const infoList = selectassettype.filter(
        (item) => typeof item === 'object' && item.extensions,
      );
      const extList = selectassettype.filter((item) => typeof item === 'string');
      infoList.forEach((info) => {
        resulta[`"${info.type}"`] = [];
      });

      extList.forEach((ext) => {
        infoList.forEach((info) => {
          if (info.extensions.includes(ext)) {
            resulta[`"${info.type}"`].push(ext);
          }
        });
      });
      let result;

      if (insideFolderId && noFilters) {
        result = await Axios.get(getSingleFolder + insideFolderId);
      } else {
        result = await Axios.post(`${GET_INSIDE_FOLDER_DATA}`, {
          searchKeyword: isExtension ? searchExtesionValue : search,
          orientations: selectorientation,
          ...(!isExtension && {
            filterTypeExtension: resulta,
          }),
          dominantColor: selectedColor,
          folderIds: folderselect,
          personCount: selectedFace,
          uploadedBy: uploadedData?.includes('By me')
            ? true
            : uploadedData?.includes('By Others')
              ? false
              : '',
          ...(selectdate?.isCustom ? { ...filteredSelectDate } : { startDate: `${selectdate}` }),
          // ...(insideFolderId && {
          //   parentFolderId: insideFolderId,
          // }),
          tagList: tagValue,
          clientId: user?.userID,
        });
      }

      !insideFolderId && setIsLoading(false);

      const _folders_data = {
        data: {
          folders: [
            {
              folders: result?.data?.data?.folders,
            },
          ],
        },
      };

      dispatch(
        SetSelctedFoldersData(
          result?.data?.data?.folders?.map((item) => ({
            ...item,
            isSelected: false,
          })),
        ),
      );
      setAllFoldersData(_folders_data);
      setAssets(result?.data?.data);
      dispatch(SelectedAssetData(result?.data?.data?.files));
    } catch (err) {
      !insideFolderId && setIsLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    if (isfirstLoad) {
      setIsFirstLoad(false);
      fetchFolders();
      dispatch(setInsideFolderData(true));
      getAllFolders();
      datashow();
      return;
    } else {
    }
    const delaysearcfun = setTimeout(async () => {
      getAllSearchData();
    }, 500);
    return () => clearTimeout(delaysearcfun);
  }, [
    selectedFormats,
    selectorientation,
    selectassettype,
    selectdate,
    folderselect,
    tagValue,
    debouncedSearch,
    selectedColor,
    assetTags,
    selectedFace,
    uploadedData,
    searchExtesionValue,
    metaData?.currentPage,
    search,
  ]);

  const handleOrientationChange = (orientation) => {
    setselectorientation((prevOrientations) => {
      if (prevOrientations.includes(orientation)) {
        return prevOrientations.filter((item) => item !== orientation);
      } else {
        return [...prevOrientations, orientation];
      }
    });
  };

  const handleAssetType = (assettype) => {
    setselectassettype((prevtype) => {
      if (prevtype.includes(assettype)) {
        return prevtype.filter((item) => item !== assettype);
      } else {
        if (assettype?.extensions) {
          return [...prevtype, assettype];
        } else {
          return [...prevtype, assettype];
        }
      }
    });
  };

  const today = new Date();

  const handlereset = () => {
    setIsFirstLoad(true);
    setSelectedFormats([]);
    setfiltereddata([]);
    setIsCustomValue(false);
    setselectorientation([]);
    setSelectDateValidator([]);
    setselectassettype([]);
    setselectdate('');
    setcreatedon([]);
    setIsExtension(false);
    setfolderselect([]);
    setSelectedColor([]);
    setUploadedData([]);
    setSelectedFace();
    setTagValue([]);
  };

  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);

    const orientation = urlObj.searchParams.get('orientation');
    const assettype = urlObj.searchParams.get('assettype');

    if (orientation) {
      setAssets([]);
      handleOrientationChange(orientation);
      setfiltereddata([orientation]);
    }
    if (assettype) {
      setfiltereddata([assettype]);

      setAssets([]);
      handleAssetType(assettype);
    }
  }, []);

  const toggle = () => {
    setModal(true);
    setshowupload(false);
    setaddcollection(false);
    setaddcollection(false);
  };

  const closeBtn = (
    <img
      src={close}
      className="close"
      onClick={() => setModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const options = {
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      let percent = Math.floor((loaded * 100) / total);
      if (percent < 100) {
        setLoaded(loaded);
        setTotal(total);
        setUploadPercentage(percent);
      }
    },
  };

  const uploadFiles = async () => {
    setDisableDropBox(true);
    let data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append('files', files[i]);
    }
    data.append('folderId', folderId);
    const res = await Axios.post(UploadAssetsURL, data, options);
    setFiles(res?.data?.data);
    setUploadPercentage(100);
    setModal(false);
    navigate(-1);
    datashow();
  };

  const fetchFolder = async () => { };

  useEffect(() => {
    (async () => {
      try {
        const result = await Axios.get(GET_ASSET_TYPE_FILTER_DATA);
        setfilterAssetType(result?.data?.data);
      } catch (err) {
        console.error(err);
      }
    })();
    fetchFolder();
  }, []);

  useEffect(() => {
    if (isCollectionAdded) {
      // Reset the state after handling it
      setIsCollectionAdded(false);
    }
  }, [isCollectionAdded]);

  const fetchFolders = async () => {
    setIsLoading(true);

    try {
    } catch (error) { }
  };

  const getAllFolders = async (isErase = false) => {
    try {
      setIsLoading(true);

      const { data } = await Axios.get(folderdata + `?pageNo=${0}&rowSize=100`); //folderdata
      const _folders_data = {
        data: {
          folders: [
            {
              folders: data?.data?.folders?.flatMap((item) => item.folders),
            },
          ],
        },
      };

      const folderIds = data?.data?.folders
        ?.flatMap((item) =>
          item.folders.map((folder) => ({
            ...folder,
          })),
        )
        ?.map((folder) => folder?.id);

      const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);

      dispatch(
        SetSelctedFoldersData(
          data?.data?.folders?.flatMap((item) =>
            item.folders.map((folder) => ({
              ...folder,
              isSelected: selectedFolders?.find((d) => d.id === folder.id)?.isSelected ?? false,
              color: folder_related_color?.data?.data?.find((d) => d.folderId === folder.id)?.color,
            })),
          ),
        ),
      );

      setAllFoldersData(_folders_data);
      dispatch(setInsideFolderData(true));
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);

      console.error(err);
    }
  };

  // useEffect(() => {
  //   fetchFolders();
  //   dispatch(setInsideFolderData(true));
  //   getAllFolders();
  //   datashow();
  // }, []);

  const collectiondataadd = () => {
    setaddcollection(true);
  };

  const handleclose = () => {
    setaddcollection(false);
    setsubfolder([]);
  };

  const HanldeImageSave = async () => {
    datashow();
  };

  const closeBtn2 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => handleclose()}
      style={{ cursor: 'pointer' }}
    />
  );
  const closeBtnFolderAddition = (
    <img
      src={close}
      alt="close"
      className="close"
      onClick={() => setOpenFolderModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const folderaddded = async () => {
    setLoadingValue(true);
    if (!textvalue == '') {
      try {
        const formData = new FormData();
        formData.append('folderName', textvalue);
        const response = await Axios.post(Addfolder, formData);
        if (response.data.success) {
          // Folder created successfully, fetch updated folder data
          toast.success(response?.data?.message ?? 'Folder created successfully'); // Moved toast.success here
          setLoadingValue(false);

          getAllFolders();
        } else {
          // Handle error case
        }
      } catch (error) {
        setLoadingValue(false);

        // Handle error
      }
    } else {
      toast.error('Please enter a valid folder name');
    }
    // Close the modal
    setOpenFolderModal(false);
  };

  const onScroll = () => {
    if (listInnerRef.current) {
      if (isLoading) return;

      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

      if (scrollTop + clientHeight >= scrollHeight) {
        if (isAvailableData) {
          setIsLoading(true);

          setMetaData((prev) => {
            return {
              ...prev,
              currentPage: prev.currentPage + 1,
              isScrolling: true,
              external: 'no',
            };
          });
        }
      }
    }
  };
  useEffect(() => {
    setScrollHandler(() => onScroll);
  }, []);
  const { getRootProps, isDragActive } = useDropzone({
    noClick: true,
    noKeyboard: true,
    multiple: true,
    onDrop: (acceptedFiles) => {
      uploadFiless(acceptedFiles);
      // if (onUpload) {
      //   onUpload(acceptedFiles, Data);
      // }
    },
  });

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setImageSearchModal(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const assetsRef = useRef(selectedAssets);
  const folderRef = useRef(selectedFolders);

  useEffect(() => {
    assetsRef.current = selectedAssets;
    folderRef.current = selectedFolders;
  }, [selectedAssets, selectedFolders]);
  const cleanerFunction = (data) => {
    dispatch(
      SelectedAssetData(
        assetsRef.current?.map((item) => ({
          ...item,
          isSelected: false,
        })),
      ),
    );
    dispatch(
      SetSelctedFoldersData(
        folderRef.current?.map((item) => ({
          ...item,
          isSelected: false,
        })),
      ),
    );
  };
  // useEffect(() => {
  //   function handleClickOutside(e) {
  //     if (
  //       box1Ref.current &&
  //       !box1Ref.current.contains(e.target) &&
  //       box2Ref.current &&
  //       !box2Ref.current.contains(e.target) &&
  //       box3Ref.current &&
  //       !box3Ref.current.contains(e.target)
  //     ) {
  //       cleanerFunction(assetsRef.current); // always latest value
  //       // also latest here
  //     }
  //   }

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => document.removeEventListener('mousedown', handleClickOutside);
  // }, []);
  return (
    <>
      <Modal
        isOpen={visualSearchModal.open}
        toggle={() => {
          setVisualSearchModal({});
        }}
        size="xl"
        style={{ width: '50%' }}
      >
        <ModalHeader toggle={toggle} close={closeBtn}>
          Reverse Image
        </ModalHeader>
        <ModalBody className="">
          {visualSearchModal.data && (
            <div className="d-flex justify-content-center">
              <div className="previewImage">
                <img src={URL.createObjectURL(visualSearchModal.data)} alt="preview" />
              </div>
            </div>
          )}
          <div
            style={{
              maxHeight: '70vh',
              overflow: 'auto',
            }}
          >
            <div className="mt-2">
              <Assitdata
                assets={visualSearchModal?.resultValue?.map((item) => ({ ...item }))}
                datashow={datashow}
                show={true}
                showData={false}
                collectionID={collectionID}
                showRenderActionButton={false}
                collectionName={collection_name}
                showCopyLing={false}
                gridNumber={3}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal} toggle={toggle} size="xl" style={{ width: '50%' }}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          {currentModalFolderName}
        </ModalHeader>
        <ModalBody className="">
          <Uploadfile
            loadedData={loadedData}
            totalData={totalData}
            disableDropBox={disableDropBox}
            uploadPercentage={uploadPercentage}
            uploadFiles={uploadFiles}
            files={files}
            setFiles={setFiles}
            previewFlag={previewFlag}
            setPreviewFlag={setPreviewFlag}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={addcollection} toggle={collectiondataadd} size="xl" style={{ width: '50%' }}>
        <ModalHeader toggle={collectiondataadd} close={closeBtn2}>
          Upload
        </ModalHeader>
        <ModalBody>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <div
              style={{
                maxHeight: '50vh',
                minHeight: '50vh',
                overflowX: 'hidden',
                overflowY: 'auto',
              }}
            >
              <FolderData isPoppedUp={true} HandleSave={HanldeImageSave} />
            </div>
          )}
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}></ModalFooter>
      </Modal>

      <Modal
        isOpen={openFolderModal}
        toggle={() => {
          setOpenFolderModal(!openFolderModal);
        }}
        style={{ width: '50%' }}
      >
        <ModalHeader
          toggle={() => {
            setOpenFolderModal(!openFolderModal);
          }}
          close={closeBtnFolderAddition}
        >
          Add Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label="Folder Name"
            name="textvalue"
            placeholder="Enter name of folder"
            change={(e) => {
              settextvalue(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            click={() => setOpenFolderModal(false)}
            size="lg"
            color="Secondary"
          />
          <ButtonC text="" click={folderaddded} size="lg" disabled={loadingValue}>
            {' '}
            {loadingValue && <Spinner color="light" className="mx-1" size="sm" />} Save
          </ButtonC>
        </ModalFooter>
      </Modal>

      <div
        className="mb-2 d-flex justify-content-between mt-4 no-print"
        style={{
          position: 'relative',
        }}
      >
        <div className="d-flex gap-1 relative">
          <div
            className={`d-flex search-box justify-content-between p-2 `}
            style={{
              width: '30vw',
            }}
          >
            <div className="d-flex w-100">
              <img src="/manage/images/SVG/search.svg" alt="" />
              <input
                type="search"
                name=""
                placeholder="Search Assets"
                value={search}
                autoComplete="off"
                // onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
              <div
                className="d-flex align-items-center"
                onClick={() => {
                  setImageSearchModal(!imageSearchModal);
                }}
                style={{
                  cursor: 'pointer',
                }}
              >
                {DAM_SVG.imageSearchIcon}
              </div>
            </div>
          </div>

          {imageSearchModal && (
            <div
              className="absolute threedotsiconclickfunction2nd  filter_upper_navigator"
              style={{
                position: 'absolute',
                top: '0px',
                width: '600px',
                padding: '20px',
                left: '40%',
              }}
              ref={wrapperRef}
            >
              <div>
                <div className="d-flex align-items-center gap-2">
                  <div>{DAM_SVG.imageSearchIcon}</div>
                  <div className="search_image_style">Search By Image</div>
                </div>
              </div>
              <div>
                <DropZone
                  setimage={(value) => {
                    setImageSearchLoading(true);
                    setTimeout(() => {
                      setImageSearchLoading(false);
                      navigate('/dam/v2/reverse-image', {
                        state: { data: value },
                      });
                      setVisualImageData(value);
                    }, 2000);
                  }}
                  Description={''}
                  Heading={
                    <p>
                      Drop Your Image here or{' '}
                      <span className="color-underline">Upload and Image</span>
                    </p>
                  }
                  Loading={imageSearchLoading}
                  fullScreen={true}
                />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex gap-2" ref={box3Ref}>
          {selectedAssets?.filter((item) => item?.isSelected)?.length > 0 ||
            selectedFolders?.filter((item) => item?.isSelected)?.length > 0 ? (
            <SelectionActions
              handleDelete={() => {
                datashow(true);
                getAllFolders(true);
              }}
              HandleAssetMove={() => {
                datashow(true);
                getAllFolders(true);
              }}
              HandleFolderCreation={() => {
                getAllFolders();
              }}
            />
          ) : (
            <div
              className="d-flex justify-content-end relative"
              style={{
                position: 'relative',
              }}
            >
              <CommonSidePortal
                activeId={activeId}
                setActiveId={setActiveId}
                portalId={0}
                ViewSection={
                  !collectionID && (
                    <ButtonC
                      size="lg"
                      click={() => {
                        // setOpenAdditionDialog(!openAdditionDialog);
                      }}
                    >
                      <span className="d-flex gap-2 justify-content-center items-center text-center align-items-center">
                        {DAM_SVG?.additionIconSvg} Add
                      </span>
                    </ButtonC>
                  )
                }
                OpenSection={
                  <div className="openAdditionDialog">
                    <div
                      onClick={() => {
                        dispatch(setInnerFolderDetails());
                        navigate('/dam/v2/uploads');
                      }}
                    >
                      {DAM_SVG.uploadSvgIcon} Asset Upload
                    </div>
                    <div
                      onClick={() => {
                        setActiveId();
                        setOpenFolderModal(true);
                        setOpenAdditionDialog(false);
                      }}
                    >
                      {DAM_SVG.addiitonSvgIcon} New Folder
                    </div>
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
      <div
        className='div-width-print'
        style={{
          position: 'relative',
        }}
      >
        <div className="visible-visibility d-flex justify-content-end ">
          {' '}
          <div
            className="d-flex justify-content-end mt-2"
            style={{
              width: '100%',
            }}
          >
            <div
              onClick={() => {
                setOpenFolderSection(!openFolderSection);
              }}
            >
              {' '}
              {SVG.filterIcon}
            </div>
          </div>
        </div>

        <div className="responsive_display_layout justify-content-between align-items-center">
          <div
            className={`d-flex align-items-center gap-2 mt-4  ${openFolderSection ? 'threedotsiconclickfunction2nd openFolderSectionDesign' : 'hidden-visibility'} `}
          >
            <Viewbuttonfolderv2
              text="Asset Type" // Label Name
              value="assettype" // for checking eith the tab is actio
              onSelectFilter={handleAssetType} // handleing after selction checkbox
              selectedFormats={filterAssetType} // FIlter Data
              setDesignationdata={setDesignationdata}
              inputSearch={searchExtesionValue} //Search Value
              setInputSearch={setSearchExtensionValue} // set Search Value
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectassettype} // Data which is visible in
              isExtension={isExtension} // check is extension or not
              setIsExtension={setIsExtension} // set value of exgtension
              isSubFilter={true} // for showing the vlaue on right side
            />
            <Viewbuttonfolderv2
              text="Orientation"
              value="orientations"
              onSelectFilter={handleOrientationChange}
              selectedFormats={[
                { id: 1, label: 'Landscape' },
                { id: 2, label: 'Portrait' },
                { id: 3, label: 'Square' },
              ]}
              setDesignationdata={setDesignationdata}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectorientation}
            />

            <Viewbuttonfolderv2
              text="Creation Date"
              value="creationDate"
              onSelectFilter={(value) => {
                setselectdate(selectdate === value ? '' : value);
                setSelectDateValidator(selectdate === value ? [] : [value]);
              }}
              selectedFormats={[
                { id: 0, label: 'Today' },
                { id: 7, label: 'Last 7 days' },
                { id: 30, label: 'Last 30 days' },
                { id: 90, label: 'Last 90 days' },
                { id: 180, label: 'Last 180 days' },
              ]}
              today={today}
              setDesignationdata={setDesignationdata}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selecttDateValidator}
              setcreatedon={setcreatedon}
              createdon={createdon}
              customValue={iscustomValue}
              setCustomValue={setIsCustomValue}
            />

            <Viewbuttonfolderv2
              text="Folder"
              value="folder"
              datashow={datashow}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={folderselect}
              setstate={setfolderselect}
            />
            <Viewbuttonfolderv2
              text="Color"
              value="color"
              datashow={datashow}
              selectedValue={selectedColor}
              onSelectFilter={setSelectedColor}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectedColor}
              setstate={setfolderselect}
            />
            <Viewbuttonfolderv2
              text="Faces"
              value="face"
              datashow={datashow}
              selectedValue={selectedFace}
              onSelectFilter={setSelectedFace}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectedFace}
              setstate={setfolderselect}
            />

            <Viewbuttonfolderv2
              text="Uploaded By"
              value="uploadedby"
              onSelectFilter={(value) => {
                if (uploadedData?.includes(value)) {
                  setUploadedData([]);
                } else {
                  setUploadedData([value]);
                }
              }}
              selectedFormats={[
                { id: 1, label: 'By me' },
                { id: 2, label: 'By Others' },
              ]}
              today={today}
              setDesignationdata={setDesignationdata}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={uploadedData}
              state={uploadedData}
              setcreatedon={setcreatedon}
              createdon={createdon}
            />

            <Viewbuttonfolderv2
              text="Tags"
              value="tags"
              datashow={datashow}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={tagValue}
              setstate={setTagValue}
            />
            <button className="resetbtn" onClick={handlereset}>
              Reset
            </button>
          </div>

          <div className="d-flex justify-content-end">
            <CommonTableDrived
              ClickedValue={(value) => {
                setSelectedTab(value);
              }}
              selectedValueData={selectedTab}
            />
          </div>

          {/* <div
            className="toggle-container flex gap-2 "
            style={{
              gap: '8px',
            }}
          >
            <div
              className={`toggle-container-inner   ${selectedTab === 'Grid' ? 'toggle-container-inner-selected' : ''}`}
              onClick={() => {
                setSelectedTab('Grid');
              }}
            >
              {DAM_SVG.gridViewIcon}
            </div>
            <div
              className={`toggle-container-inner ${selectedTab === 'Table' ? 'toggle-container-inner-selected' : ''}`}
              onClick={() => {
                setSelectedTab('Table');
              }}
            >
              {DAM_SVG.tableViewIcon}
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="dis_grid grid_cols_5">
        <ImageGridSecondVersion />
      </div> */}

      <div
        // className='Print-main '
        style={{
          marginTop: '1rem',
        }}
      >
        {selectedTab?.id === 2 ? (
          <></>
        ) : (
          <div ref={box1Ref}>
            <GridFolderData
              isPoppedUp={true}
              isUpload={false}
              data={allFoldersData}
              setdata={setAllFoldersData}
              innerfolderValue={isInsideFolder}
              HandleDelete={() => {
                getAllFolders();
                datashow();
              }}
              showPagination={false}
            />
          </div>
        )}

        {isInsideFolder && (
          <>
            {assets?.files?.length === 0 && isLoading ? (
              <div className=" d-flex align-item-center justify-content-center">
                {isLoading ? (
                  <div className="w-10">
                    <Spinner />
                  </div>
                ) : (
                  <div className="w-50">
                    <Nodatacomponent text={'No Asset Found'} />
                  </div>
                )}
              </div>
            ) : (
              <div
                {...getRootProps()}
                // style={{
                //   position: 'relative',
                //   minHeight: '60vh',
                // }}
                className='RerativeClass'
              >
                {isDragActive && (
                  <div
                    style={{
                      position: 'absolute',
                      zIndex: 99999,
                      height: '100%',
                      width: '100%',
                      backgroundColor: '#21cfd670',
                    }}
                  ></div>
                )}
                {selectedTab?.id === 1 && (
                  <div ref={box2Ref}>
                    <Assitdata
                      assets={assets?.files?.map((item) => ({ ...item }))}
                      datashow={datashow}
                      show={true}
                      showData={false}
                      collectionID={collectionID}
                      showRenderActionButton={false}
                      collectionName={collection_name}
                      showCopyLing={false}
                    />
                  </div>
                )}

                {selectedTab?.id === 2 && (
                  <CommonTable
                    data={[
                      ...(Array.isArray(selectedFolders)
                        ? selectedFolders.map((item) => ({
                          ...item,
                          assetName: item?.folderName,
                          assetType: 'Folder',
                          type: 'assetsFolder',
                          typeIdentification: 1,
                        }))
                        : []),
                      ...(Array.isArray(assets?.files)
                        ? assets.files.map((item) => ({
                          ...item,
                          type: 'assetsImage',
                          typeIdentification: 2,
                        }))
                        : []),
                    ]}
                    setAssets={setAssets}
                    files={assets?.files ?? []}
                    HandleDelete={() => {
                      getAllFolders();
                      datashow();
                    }}
                  />
                )}

                {isLoading && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: '50%',
                    }}
                  >
                    <Spinner />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AssetsData;
